import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import moment from 'moment';
import * as types from './types';
import { userLogout, forbiddenAccess, checkVersionMisMatch } from './auth';

const request = superagent
  .agent()
  .set('ETag', window.Config.APP_VERSION)
  .use(function (req) {
    req.on('response', function (res) {
      if (res.status === 401) {
        console.log('UnAuthorized');
        userLogout();
      } else if (res.status === 403) {
        console.log('Forbidden');
        forbiddenAccess();
      }
    });
  });

export function getFormResponseStart() {
  return {
    type: types.GET_FORMRESPONSE_START,
  };
}

export function getFormResponseSuccess(formresponse) {
  return {
    type: types.GET_FORMRESPONSE_SUCCESS,
    formresponse,
  };
}

export function getFormResponseFail() {
  return {
    type: types.GET_FORMRESPONSE_FAIL,
  };
}

export function getCampaignSuccess(campaignlist) {
  return {
    type: types.GET_FORMLIST_SUCCESS,
    campaignlist,
  };
}

export function getServiceSuccess(servicelist, campaignType) {
  return {
    type: types.GET_FORMSERVICES_SUCCESS,
    servicelist,
    campaignType,
  };
}

export function setCampaignType(campaignType) {
  return {
    type: types.SET_CAMPAIGNTYPE_SUCCESS,
    campaignType,
  };
}

export function getServiceStart() {
  return {
    type: types.GET_FORMSERVICES_START,
  };
}

export function getServiceFail() {
  return {
    type: types.GET_FORMSERVICES_FAIL,
  };
}

export function getFormResponse(businessId, campaignType) {
  return (dispatch, getState) => {
    dispatch(getFormResponseStart());
    request
      .get(`${window.Config.API_URL}/business/lead_engage`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          dispatch(getFormResponseSuccess(resp.body));
          dispatch(checkVersionMisMatch(resp.headers));
        } else {
          dispatch(getFormResponseFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getFormResponseFail());
      });
    request
      .get(`${window.Config.API_URL}/business/lead_engage/services`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          dispatch(getServiceSuccess(resp.body, campaignType));
        }
      })
      .catch((ex) => {
        console.log(ex);
      });
    request
      .get(`${window.Config.API_URL}/business/lead_engage/campaigns`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          dispatch(getCampaignListSuccess(resp.body));
        }
      })
      .catch((ex) => {
        console.log(ex);
      });
    request
      .get(`${window.Config.API_URL}/business/lead_engage/notification_webhook?business_id=${businessId}`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          dispatch(getWebHookSuccess(resp.body));
        }
      })
      .catch((ex) => {
        console.log(ex);
      });
  };
}

export function getWebHookSuccess(webhook) {
  return {
    type: types.GET_NOTIFICATIONWEBHOOKS_SUCCESS,
    webhook,
  };
}

export function postupdateWebHook(data, business_id) {
  return (dispatch, getState) => {
    dispatch(updateWebHookStart());
    request
      .post(`${window.Config.API_URL}/business/lead_engage/notification_webhook?business_id=${business_id}`)
      .send(data)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          dispatch(updateWebHookSuccess(resp.body));
        } else {
          dispatch(updateWebHookFailure());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(updateWebHookFailure());
      });
  };
}
export function updateWebHookStart() {
  return {
    type: types.UPDATE_NOTIFICATIONWEBHOOKS_START,
  };
}
export function updateWebHookSuccess(webhook) {
  return {
    type: types.UPDATE_NOTIFICATIONWEBHOOKS_SUCCESS,
    webhook,
  };
}
export function updateWebHookFailure() {
  return {
    type: types.UPDATE_NOTIFICATIONWEBHOOKS_FAIL,
  };
}

export function deleteWebHook(business_id) {
  return (dispatch, getState) => {
    dispatch(deleteWebHookStart());
    request
      .delete(`${window.Config.API_URL}/business/lead_engage/notification_webhook?business_id=${business_id}`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          dispatch(deleteWebHookSuccess(resp.body));
        } else {
          dispatch(deleteWebHookFailure());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(deleteWebHookFailure());
      });
  };
}
export function deleteWebHookStart() {
  return {
    type: types.DELETE_NOTIFICATIONWEBHOOKS_START,
  };
}
export function deleteWebHookSuccess(webhook) {
  return {
    type: types.DELETE_NOTIFICATIONWEBHOOKS_SUCCESS,
    webhook,
  };
}
export function deleteWebHookFailure() {
  return {
    type: types.DELETE_NOTIFICATIONWEBHOOKS_FAIL,
  };
}

export function getCampaignData() {
  return (dispatch, getState) => {
    dispatch(getCampaignDataStart());
    request
      .get(`${window.Config.API_URL}/business/lead_engage/summary`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          dispatch(getCampaignDataSuccess(resp.body));
        } else {
          dispatch(getCampaignDataFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getCampaignDataFail());
      });
  };
}
export function postCampaignData(business_id, month, campaign) {
  return (dispatch, getState) => {
    dispatch(getCampaignDataStart());
    let param = Object.assign(
      {},
      {
        year_month: month,
      },
    );
    request
      .post(`${window.Config.API_URL}/business/lead_engage/summary`)
      .send(param)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          dispatch(getCampaignDataSuccess(resp.body));
        } else {
          dispatch(getCampaignDataFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getCampaignDataFail());
      });
  };
}
export function getCampaignDataStart() {
  return {
    type: types.GET_CAMPAIGNDATA_START,
  };
}
export function getCampaignDataSuccess(campaignData) {
  return {
    type: types.GET_CAMPAIGNDATA_SUCCESS,
    campaignData,
  };
}
export function getCampaignDataFail() {
  return {
    type: types.GET_CAMPAIGNDATA_FAIL,
  };
}

export function postTrends(campaign, year_month) {
  return (dispatch, getState) => {
    // dispatch(getTrendsSuccess(trends_sample));
    dispatch(getTrendsStart());
    let param = Object.assign(
      {},
      {
        campaign_id: campaign || '',
        year_month,
      },
    );
    request
      .post(`${window.Config.API_URL}/business/lead_engage/trends`)
      .send(param)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          dispatch(getTrendsSuccess(resp.body));
        } else {
          dispatch(getTrendsFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getTrendsFail());
      });
  };
}
export function getTrendsStart() {
  return {
    type: types.GET_LETRENDS_START,
  };
}
export function getTrendsSuccess(trends) {
  return {
    type: types.GET_LETRENDS_SUCCESS,
    trends,
  };
}
export function getTrendsFail() {
  return {
    type: types.GET_LETRENDS_FAIL,
  };
}

export function getCampaignListSuccess(campaignlist) {
  return {
    type: types.GET_CAMPAIGN_LIST_SUCCESS,
    campaignlist,
  };
}

export function postFormResponse(businessid, month, campaign) {
  return (dispatch, getState) => {
    dispatch(getFormResponseStart());
    let param = Object.assign(
      {},
      {
        campaign_id: campaign || '',
        year_month: month,
      },
    );
    request
      .post(`${window.Config.API_URL}/business/lead_engage`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(param)
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          dispatch(getFormResponseSuccess(resp.body));
        } else {
          dispatch(getFormResponseFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getFormResponseFail());
      });
  };
}

export function postFormStart() {
  return {
    type: types.POST_FORM_START,
  };
}

export function postFormSuccess(form) {
  return {
    type: types.POST_FORM_SUCCESS,
    form,
  };
}

export function postFormFail() {
  return {
    type: types.POST_FORM_FAIL,
  };
}

export function postForm(params) {
  return (dispatch, getState) => {
    dispatch(postFormStart());
    let param = {
      name: params.name,
      ...(params.service_name && { service_name: params.service_name }),
      ...(params.service_id && { service_id: params.service_id }),
      ...(params.promo_code && { promo_code: params.promo_code }),
      first_message: params.first_message,
      pricing_message: params.pricing_message,
      campaign_start: moment(params.campaign_start).format('YYYY-MM-DD'),
      ...(params.campaign_expiry && {
        campaign_expiry: moment(params.campaign_expiry).format('YYYY-MM-DD'),
      }),
      follow_up_count: params.follow_up_count,
      follow_ups: params.follow_ups,
      campaign_type: params.campaign_type,
    };
    request
      .post(`${window.Config.API_URL}/business/lead_engage/campaign`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(param)
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          dispatch(postFormSuccess(resp.body));
          dispatch(getFormResponse(params.businessId, params.campaign_type));
        } else {
          dispatch(postFormFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postFormFail());
      });
  };
}

export function editFormSuccess(form) {
  return {
    type: types.EDIT_FORM_SUCCESS,
    form,
  };
}
export function putForm(params) {
  return (dispatch, getState) => {
    dispatch(postFormStart());
    request
      .put(
        `${window.Config.API_URL}/business/lead_engage/campaign/${params.id}`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          dispatch(editFormSuccess(resp.body));
        } else {
          dispatch(postFormFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postFormFail());
      });
  };
}

export function clearFormFlags() {
  return (dispatch, getState) => {
    dispatch({
      type: types.FORM_CLEAR_FLAGS,
    });
  };
}
export function postDetalsStart() {
  return {
    type: types.POST_DETAILS_START,
  };
}
export function postDetalsFail() {
  return {
    type: types.POST_DETAILS_FAIL,
  };
}

export function postDetalsSuccess(details) {
  return {
    type: types.POST_DETAILS_SUCCESS,
    details,
  };
}
export function getCampaign(params) {
  return (dispatch, getState) => {
    dispatch(postDetalsStart());
    request
      .get(
        `${window.Config.API_URL}/business/lead_engage/campaign/${params.id}`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          dispatch(postDetalsSuccess(resp.body));
          dispatch(checkVersionMisMatch(resp.headers));
        } else {
          dispatch(postDetalsFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postDetalsFail());
      });
  };
}
export function deleteFormSuccess(details) {
  return {
    type: types.DELETE_FORM_SUCCESS,
    details,
  };
}

export function DeleteCampaign(params) {
  return (dispatch, getState) => {
    dispatch(postFormStart());
    request
      .delete(
        `${window.Config.API_URL}/business/lead_engage/campaign/${params.id}`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        console.log(resp, params);
        if (resp.statusCode === 200) {
          dispatch(deleteFormSuccess(resp.body));
          dispatch(postFormResponse(params.businessId, params.year_month));
        } else {
          dispatch(postFormFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postFormFail());
      });
  };
}

export function saveLeadName(name) {
  return {
    type: types.SAVE_LEAD_NAME,
    name,
  };
}

export function getLeadReport(params) {
  return (dispatch, getState) => {
    dispatch(getLeadReportStart());
    let param = {
      campaign_id: params.id,
      year_month: params.year_month,
    };
    request
      .post(`${window.Config.API_URL}/business/lead_engage/campaign/metrics`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(param)
      .then((resp) => {
        console.log(resp, params);
        if (resp.statusCode === 200) {
          dispatch(getLeadReportSucess(resp.body));
        } else {
          dispatch(getLeadReportFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getLeadReportFail());
      });
  };
}

export function getLeadReportStart() {
  return {
    type: types.GET_LEAD_REPORT_START,
  };
}

export function getLeadReportFail() {
  return {
    type: types.GET_LEAD_REPORT_FAIL,
  };
}

export function getLeadReportSucess(report) {
  return {
    type: types.GET_LEAD_REPORT_SUCCESS,
    report,
  };
}
